import { PageWithHeader, PageWithNavigation } from "@components/templates"
import { useAuthContext } from "@context/AuthProvider"
import { useLegalAcceptance } from "../../../pages/home/termsConditionsModal/hooks/useLegalAcceptance"

interface ConditionalPageLayoutProps {
	children: React.ReactNode
	brands?: string[]
}

export function ConditionalPageLayout({
	children,
	brands
}: ConditionalPageLayoutProps) {
	const { isAuthenticated, isLoading } = useAuthContext()
	const { needsTermsOfUse, needsTravelAgentGuidelines } = useLegalAcceptance()
	if (isLoading) return null

	if (isAuthenticated && !needsTermsOfUse && !needsTravelAgentGuidelines) {
		return <PageWithNavigation>{children}</PageWithNavigation>
	}

	return <PageWithHeader brands={brands}>{children}</PageWithHeader>
}
